export default __webpack_public_path__ + "static/realWorldImg2-94b315534cfffe6741b25d1767ab420e.png";